import React from 'react';
interface TestimonialProps {
  author: string;
  location: string;
  quote: string;
}
export function TestimonialBox({
  testimonials
}: {
  testimonials: TestimonialProps[];
}) {
  // Generate consistent avatar images for each testimonial
  const getAvatarUrl = (index: number) => {
    const femaleIds = [68, 33, 12, 90, 45, 22, 55, 28, 76, 19];
    return `https://randomuser.me/api/portraits/women/${femaleIds[index % femaleIds.length]}.jpg`;
  };
  return <div className="my-8 p-6 border-2 border-dashed border-gray-300 rounded-lg bg-blue-50/30 space-y-6" data-id="element-126">
      {testimonials.map((testimonial, index) => <div key={index} className={`flex gap-4 ${index !== testimonials.length - 1 ? 'mb-6 pb-6 border-b border-gray-200' : ''}`} data-id="element-127">
          <div className="flex-shrink-0" data-id="element-128">
            <img src={getAvatarUrl(index)} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-gray-300" data-id="element-129" />
          </div>
          <blockquote className="flex-1" data-id="element-130">
            <p className="text-base text-gray-800 mb-2 font-serif leading-relaxed" data-id="element-131">
              "{testimonial.quote}"
            </p>
            <footer className="text-sm font-bold text-gray-900" data-id="element-132">
              — {testimonial.author}, {testimonial.location}
            </footer>
          </blockquote>
        </div>)}
    </div>;
}